import React from "react";
import parse from 'html-react-parser';
import styles from './Item.module.css';

const Item = (props) => {
  var itemProps = props.items.map((row) => {
    if(row.id === props.id)
    {
      var noteNumber = '';
      var noteBody = '';
      if(row.noteNumber !== '') {
        noteNumber = ' [' + row.noteNumber + ']';
        noteBody = '<div><span className="' + styles.note +  '">' + noteNumber + '</span> ' + row.noteBody + '</div>';
        noteBody = parse(noteBody);
      }
      return (
          <div key={props.id}>
            <div className={styles.label}>{props.id}. {parse(row.title)}<span className={styles.note}>{noteNumber}</span></div>
            <div>{parse(row.body)}</div>
            {noteBody}
          </div>
      );
    } else {
      return '';
    }
  });

  return (
    <div className={styles.item}>
      {itemProps}
    </div>
  );
};

export default Item;
